<template>
  <v-container pa-0 fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row :style="{height: fullHeight}" justify="center" align="center" no-gutters>
          <div class="text-center py-10">
            <v-icon size="100" color="primary">{{ titleIcon }}</v-icon>
            <div class="headline font-weight-bold mt-5 mb-5">{{ title }}</div>
            <div class="subtitle-1">{{ description }}</div>
            <v-col>
              <v-row class="d-flex justify-center">
                <v-btn v-if="reloadButton" @click="$reloadApp" class="mt-5" color="primary">
                  <v-icon :color="ButtonIconColor" left>mdi-refresh</v-icon>
                  {{ $t('reload') }}
                </v-btn>
              </v-row>
              <v-row v-if="hasEditRights" class="d-flex justify-center">
                <v-btn v-if="functionButton" @click="propFunction" class="mt-5" color="primary">
                  <v-icon :color="ButtonIconColor" left>{{ functionButtonIcon }}</v-icon>
                  {{ functionButtonText }}
                </v-btn>
              </v-row>
            </v-col>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NoContentView',
  props: {
    titleIcon: String,
    title: String,
    description: String,
    reloadButton: {
      type: Boolean,
      default: true,
    },
    functionButton: {
      type: Boolean,
      default: false,
    },
    fillHeight: {
      type: Boolean,
      default: false
    },
    hasEditRights: {
      type: Boolean,
      default: true
    },
    topBarHeight: String,
    propFunction: Function,
    functionButtonIcon: String,
    ButtonIconColor: String,
    functionButtonText: String,
  },
  computed: {
    fullHeight() {
     return this.fillHeight && 'calc(100vh - ' + this.topBarHeight + 'px)';
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
